import React, { useContext, useEffect, useMemo, useState } from 'react';
import { calculateFontSize, getConfig, sendNotification } from 'utils/helperMethods';
import LowerLevelSection, {
    limitAltMessage,
    limitMessage,
} from 'components/atoms/PromoRecommendation/LowerLevelSection';
import { promoRecommendation } from 'contexts/PromoRecommendationContext';
import _ from 'lodash';
import useFetchGetPromptsList from 'hooks/promoRecommendation/UseFetchGetPromptsListData';
import useFetchGetPromptsPreviousList from 'hooks/promoRecommendation/UseFetchGetPromtsPreviousListData';
import dayjs from 'dayjs';
import Calender from '../Calender';
import { default as CalenderIcon } from 'assets/svg/Calender';
import { Popover, notification } from 'antd';
import { FilterContextData } from 'contexts/FilterContext';
import { UserContext } from 'contexts/ConfigContext';
import UpliftRoiDropdown, { CustomSelect } from '../UpliftRoiDropdown';
import { trackEventMixpanel } from 'utils/mixpanel';
import {
    PROMO_RECOMMENDATION_ADD_EVENT_DATE_SELECTED,
    PROMO_RECOMMENDATION_ADD_EVENT_DISPLAY_ACV_CHANGED,
    PROMO_RECOMMENDATION_ADD_EVENT_DURATION_CHANGED,
    PROMO_RECOMMENDATION_ADD_EVENT_FEATURE_ACV_CHANGED,
    PROMO_RECOMMENDATION_ADD_EVENT_OFFER_DROPDOWN_CHANGED,
    PROMO_RECOMMENDATION_ADD_EVENT_OFFER_TYPE_DROPDOWN_CHANGED,
    PROMO_RECOMMENDATION_EDIT_EVENT_DATE_SELECTED,
    PROMO_RECOMMENDATION_EDIT_EVENT_DISPLAY_ACV_CHANGED,
    PROMO_RECOMMENDATION_EDIT_EVENT_DURATION_CHANGED,
    PROMO_RECOMMENDATION_EDIT_EVENT_FEATURE_ACV_CHANGED,
    PROMO_RECOMMENDATION_EDIT_EVENT_OFFER_DROPDOWN_CHANGED,
    PROMO_RECOMMENDATION_EDIT_EVENT_OFFER_TYPE_DROPDOWN_CHANGED,
} from 'utils/mixpanelEventNames';
import DownSvg from 'assets/svg/Down';
import DateSelectCombo from '../DateSelectCombo';

const currentDate = new Date();

const mixpanelMapping: any = {
    displayAcv: [
        PROMO_RECOMMENDATION_ADD_EVENT_DISPLAY_ACV_CHANGED,
        PROMO_RECOMMENDATION_EDIT_EVENT_DISPLAY_ACV_CHANGED,
    ],
    featureAcv: [
        PROMO_RECOMMENDATION_ADD_EVENT_FEATURE_ACV_CHANGED,
        PROMO_RECOMMENDATION_EDIT_EVENT_FEATURE_ACV_CHANGED,
    ],
    duration: [PROMO_RECOMMENDATION_ADD_EVENT_DURATION_CHANGED],
};

function AddEditLevers() {
    type DateRangeType = [Date | null, Date | null];
    const [isOpen, setIsOpen] = useState(false);

    const {
        addLeverData,
        setAddLeverData,
        editMode: edit,
        tempRange,
        stateForCalender,
        setTempRange,
        setStateForCalender,
        editOriginalData,
        editRowData,
        eventsDataFormat,
        selectedPlan,
        PreviousUpliftValue,
        PromotionMechanicValue,
    } = useContext(promoRecommendation);
    const scaledWidth = calculateFontSize(window.innerWidth, 200);

    const { idForRestOfComponent, allCheckedAttribute } = useContext(FilterContextData);
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const dateFormatAlt = commonConfig?.dateFormatAlt;
    const promoContext = getConfig('promoRecommendation', appConfig);
    const retailerKey = promoContext.retailerKey;
    const promoTypeColorMapping: any = promoContext.promoTypeColorMapping;
    const calenderStartDay = promoContext?.calenderStartDay || 'Monday';
    const [offerMethod, setOfferMethod] = useState(appConfig.promoRecommendation.offerMethodList[0]); // todo get the other options from config
    const [offerMethodOption, setOfferMethodoption] = useState(false);
    const [mechanicEditValue, setMechanicEditValue] = useState('');

    //onChange function for form
    function changeInputForm(e: any, item: any, string = false) {
        const targetValue = typeof e == 'number' ? e : e.target.value;
        if (
            (item.value === 'duration' && !string && parseInt(targetValue) > 52) ||
            parseInt(targetValue) < 0 ||
            targetValue == '-'
        ) {
            notification.open({
                message: limitAltMessage,
                className: 'custom-class',
                style: {
                    width: 350,
                    height: 70,
                },
            });
            return;
        }
        if ((!string && parseInt(targetValue) > 100) || parseInt(targetValue) < 0 || targetValue == '-') {
            notification.open({
                message: limitMessage,
                className: 'custom-class',
                style: {
                    width: 350,
                    height: 70,
                },
            });
            return;
        }
        setAddLeverData((oldData: any) => {
            let cloneDeep = _.cloneDeep(oldData);
            cloneDeep[item.value] = string ? targetValue : parseInt(targetValue);
            return cloneDeep;
        });
    }

    const handleManualInput = (e: any, string = false) => {
        if ((!string && parseInt(e.target.value) > 90) || parseInt(e.target.value) < 0 || e.target.value == '-') {
            sendNotification('error', 'Error: Please provide values <=90 and >= 0');
            return;
        }
    };

    const {
        loading: offerListLoading,
        error: offerListError,
        data: offerListData,
        fetchPromptList: fetchOfferList,
    } = useFetchGetPromptsList();
    const {
        loading: offerPreviousListLoading,
        error: offerPreviousListError,
        data: offerPreviousListData,
        fetchPromptPreviousList: fetchOfferPreviousList,
    } = useFetchGetPromptsPreviousList();
    const {
        loading: offerTypeLoading,
        error: offerTypeError,
        data: offerTypeData,
        fetchPromptList: fetchOfferTypeList,
    } = useFetchGetPromptsList();
    const {
        loading: calenderListLoading,
        error: calenderListError,
        data: calenderList,
        fetchPromptList: fetchCalenderList,
    } = useFetchGetPromptsList();
    const {
        loading: durationLoading,
        error: durationError,
        data: durationList,
        fetchPromptList: fetchDurationList,
    } = useFetchGetPromptsList();

    //format filter for prompt list ppg selection + global filter
    let globalFilterForOffer = useMemo(() => {
        let tempFilter = _.cloneDeep(commonConfig.filterFormat);
        tempFilter.dim2 = idForRestOfComponent['dim2'];
        let dim1Ids: any = [];
        if (Object.keys(addLeverData['SelectedLowerLevel']).length) {
            Object.keys(addLeverData['SelectedLowerLevel']).forEach((key: any) => {
                dim1Ids.push(addLeverData['SelectedLowerLevel'][key].dim1Id);
            });
            tempFilter.dim1 = { ids: dim1Ids };
        } else {
            tempFilter.dim1 = { ids: [] };
        }
        return tempFilter;
    }, [idForRestOfComponent, addLeverData]);

    let eventDataAll = useMemo(() => {
        let data = eventsDataFormat(editRowData);
        return data;
    }, [editRowData, idForRestOfComponent, addLeverData]);

    function callPromoMechanics() {
        //if offer type is present then only insert the eventData
        let eventData: any = {};
        if (edit) {
            eventData = { ...eventDataAll };
        } else {
            if ('tacticDescription' in addLeverData) {
                eventData['tacticDescription'] = addLeverData['tacticDescription'].promptName;
            }
        }
        fetchOfferList({
            variables: {
                filters: JSON.stringify(globalFilterForOffer),
                selectedField: 'promotion_mechanic',
                eventData: JSON.stringify(eventData),
                planId: selectedPlan.planId,
                isEdit: edit,
                dim2AttributeName: `${Object.keys(allCheckedAttribute?.[retailerKey])?.[0]}`,
            },
        });
    }

    function callPromoPreviousMechanics() {
        //if offer type is present then only insert the eventData
        let eventData: any = {};
        if (edit) {
            eventData = { ...eventDataAll };
        } else {
            if ('tacticDescription' in addLeverData) {
                eventData['tacticDescription'] = addLeverData['tacticDescription'].promptName;
            }
        }
        fetchOfferPreviousList({
            variables: {
                filters: JSON.stringify(globalFilterForOffer),
            },
        });
    }

    function callTactics() {
        //if offer is present then only insert the eventData
        let eventData: any = {};
        if ('promotionMechanic' in addLeverData) {
            eventData['promotionMechanic'] = addLeverData['promotionMechanic'];
        } else if (edit) {
            eventData['promotionMechanic'] = editOriginalData['promotionMechanic'];
        }

        fetchOfferTypeList({
            variables: {
                filters: JSON.stringify(globalFilterForOffer),
                selectedField: 'tactic_description',
                eventData: JSON.stringify(eventData),
                planId: selectedPlan.planId,
                isEdit: edit,
                dim2AttributeName: `${Object.keys(allCheckedAttribute?.[retailerKey])?.[0]}`,
            },
        });
    }

    function callCalender() {
        fetchCalenderList({
            variables: {
                filters: JSON.stringify(globalFilterForOffer),
                selectedField: 'start_date',
                eventData: JSON.stringify(eventDataAll),
                isEdit: edit,
                planId: selectedPlan.planId,
                dim2AttributeName: `${Object.keys(allCheckedAttribute?.[retailerKey])?.[0]}`,
            },
        });
    }

    function callDuration() {
        fetchDurationList({
            variables: {
                filters: JSON.stringify(globalFilterForOffer),
                selectedField: 'duration',
                eventData: JSON.stringify(eventDataAll),
                isEdit: edit,
                planId: selectedPlan.planId,
                dim2AttributeName: `${Object.keys(allCheckedAttribute?.[retailerKey])?.[0]}`,
            },
        });
    }

    //onchange of input
    function changeInSelection(key: any, item: any) {
        setAddLeverData((data: any) => {
            let cloneData = _.cloneDeep(data);
            cloneData[key] = item;
            return cloneData;
        });
    }

    //
    const handleOpenChange = (
        newOpen: boolean,
        isClickOutside: boolean = true,
        from: 'header' | 'dateRange' = 'dateRange',
    ) => {
        setIsOpen(newOpen);
        if (!newOpen && !isClickOutside) {
            //only save the date when clicked on set date button
            const date = dayjs(new Date(tempRange[1])).format('YYYY-MM-DD');
            setStateForCalender((prev: any) => ({ ...prev, dateRange: tempRange }));
            changeInSelection('startDate', date);
            changeInSelection('month', dayjs(new Date(tempRange[1])).format('MMM'));
            trackEventMixpanel(PROMO_RECOMMENDATION_ADD_EVENT_DATE_SELECTED, {
                selectedDate: date,
            });
        } else if (!newOpen) setTempRange([...stateForCalender.dateRange]); //if clicked outside dont save the change
    };

    const dateLabel = useMemo(() => {
        let startLabel = 'Start Date';
        const { dateRange } = stateForCalender;
        if (dateRange[1]) startLabel = dayjs(new Date(dateRange[1])).format(commonConfig?.dateFormat);
        return { startLabel };
    }, [stateForCalender]);

    const handleDateChange = (range: DateRangeType) => {
        setTempRange([...range]);
    };

    const content = useMemo(() => {
        switch (offerMethod.value) {
            case 'option':
                return (
                    <div className="col-span-6 flex justify-end">
                        <UpliftRoiDropdown
                            style={{ width: scaledWidth - 2 }}
                            loading={offerListLoading}
                            value={!offerMethodOption ? addLeverData['promotionMechanic'] : {}}
                            data={offerListData}
                            onChange={(val: any, item: any) => {
                                setOfferMethodoption(false);
                                changeInSelection('promotionMechanic', val);
                                if (edit) {
                                    trackEventMixpanel(PROMO_RECOMMENDATION_EDIT_EVENT_OFFER_DROPDOWN_CHANGED, {
                                        modifiedValue: item?.item?.label,
                                        originalValue: editOriginalData['promotionMechanic'] || '',
                                    });
                                } else {
                                    trackEventMixpanel(PROMO_RECOMMENDATION_ADD_EVENT_OFFER_DROPDOWN_CHANGED, {
                                        dropdownValue: item?.item?.label,
                                    });
                                }
                            }}
                            disabled={offerListLoading}
                            originalROI={edit ? editOriginalData['roi'] : ''}
                            originalUPlift={edit ? editOriginalData['uplift'] : ''}
                            onClick={callPromoMechanics}
                        />
                    </div>
                );
            case 'manual':
                return (
                    <div className="col-span-6 flex justify-end">
                        <span className="border border-purpleFont rounded" style={{ width: scaledWidth - 2 }}>
                            <input
                                onWheel={(e) => e.currentTarget?.blur()}
                                min={'0'}
                                className="m-0.5 focus:outline-none pl-2"
                                style={{ width: scaledWidth - 6 }}
                                value={'discount' in addLeverData ? addLeverData['discount'] : {}}
                                placeholder="Enter discount (0-90%)"
                                onChange={(e) => {
                                    let value = e.target.value;
                                    value.length > 2 ? (value = value.slice(0, 2)) : value;
                                    changeInSelection('discount', value);
                                    handleManualInput(e);
                                }}
                                type="number"
                            />
                        </span>
                    </div>
                );
            case 'previous':
                return (
                    <div className="col-span-6 flex justify-end">
                        <UpliftRoiDropdown
                            style={{ width: scaledWidth - 2 }}
                            loading={offerPreviousListLoading}
                            value={'promptEventName' in addLeverData ? addLeverData['promptEventName'] : {}}
                            data={offerPreviousListData}
                            onChange={(val: any, item: any) => {
                                changeInSelection('promptEventName', val);

                                offerPreviousListData.map((item: any, index: number) => {
                                    // Added index parameter
                                    if (item.eventName === val) {
                                        PreviousUpliftValue(item.uplift);
                                        PromotionMechanicValue(item.promotionMechanic);
                                        setMechanicEditValue(item.promotionMechanic);
                                        // Checking if eventName matches val
                                        promoContext.formList.map((value: any, index: any) => {
                                            if (index === 1) {
                                                changeInputForm(item.displayAcv, value);
                                            } else if (index === 2) {
                                                changeInputForm(item.featureAcv, value);
                                            }
                                        });
                                    }
                                });

                                if (edit) {
                                    trackEventMixpanel(PROMO_RECOMMENDATION_EDIT_EVENT_OFFER_DROPDOWN_CHANGED, {
                                        modifiedValue: item?.item?.label,
                                        originalValue: editOriginalData['promotionMechanic'] || '',
                                    });
                                } else {
                                    trackEventMixpanel(PROMO_RECOMMENDATION_ADD_EVENT_OFFER_DROPDOWN_CHANGED, {
                                        dropdownValue: item?.item?.label,
                                    });
                                }
                            }}
                            disabled={offerPreviousListLoading}
                            originalROI={edit ? editOriginalData['roi'] : ''}
                            originalUPlift={edit ? editOriginalData['uplift'] : ''}
                            onClick={callPromoPreviousMechanics}
                        />
                    </div>
                );
            default:
                return null; // Or you can return a default content here
        }
    }, [
        offerMethod.value,
        offerMethodOption,
        addLeverData,
        edit,
        editOriginalData,
        offerListData,
        offerListLoading,
        offerPreviousListLoading,
        scaledWidth,
        changeInSelection,
        trackEventMixpanel,
        callPromoMechanics,
    ]);

    return (
        <div className="flex flex-col px-4  w-full border-collapse">
            <span className="font-lg font-medium">{edit ? 'Edit Levers' : 'Add Levers'}</span>
            {/* Lever PPG Form */}
            <LowerLevelSection />
            {/* Lever Edit Form */}
            <div className=" border-solid border-0 border-x border-b border-borderLinePurpuleAlt rounded-b">
                <div className="flex w-full justify-between bg-bgBackground border-0 border-b border-borderLinePurpuleAlt text-purpleFont font-medium">
                    <div className="flex w-full">
                        <div className="flex py-2 pl-2">
                            <span>Levers</span>
                        </div>
                    </div>
                    {edit && (
                        <div className="flex w-full -ml-4">
                            <div className="flex py-2 pl-2 justify-start items-center w-full">
                                <span>Original</span>
                            </div>
                        </div>
                    )}
                    <div className="flex w-full">
                        <div className="flex py-2 pl-2 justify-center w-full">
                            <span>Modified</span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col">
                    {/* offer types */}
                    <div
                        className={`${
                            edit ? `grid grid-cols-12 grid-container` : `flex justify-between`
                        } w-full items-center border-0 border-b border-borderLinePurpuleAlt p-2 !text-fontGray`}
                    >
                        <span className="font-xxs !text-fontGray font-medium col-span-4">Offer Method</span>
                        {edit && (
                            <span className="font-xxs !text-fontGray col-span-2">
                                {editOriginalData['offerMethod']}
                            </span>
                        )}
                        <div className="col-span-6 flex justify-end">
                            <CustomSelect
                                suffixIcon={<DownSvg />}
                                className="col-span-6 flex justify-end dropdown-height dropdown-widtxh uniqSelOIBubbleDropdown"
                                value={'offerMethod' in addLeverData ? addLeverData['offerMethod'] : {}}
                                options={appConfig.promoRecommendation.offerMethodList} // todo get the other options from config
                                onChange={(val: any, item: any) => {
                                    changeInSelection('offerMethod', val);
                                    setOfferMethod(item);
                                    val === 'option' ? setOfferMethodoption(true) : setOfferMethodoption(false);
                                    val === 'manual' ? (addLeverData.promotionMechanic = '') : '';
                                }}
                                style={{ width: scaledWidth - 2 }}
                            />
                        </div>
                    </div>
                    {/* offer dropdown */}
                    <div
                        className={`${
                            edit ? `grid grid-cols-12 grid-container` : `flex justify-between`
                        } w-full items-center border-0 border-b border-borderLinePurpuleAlt p-2 !text-fontGray`}
                    >
                        {!edit &&
                            (((offerMethod.value === null || offerMethod.value === 'option') && (
                                <span className="font-xxs !text-fontGray font-medium col-span-4">Offer</span>
                            )) ||
                                (offerMethod.value === 'previous' && (
                                    <span className="font-xxs !text-fontGray font-medium col-span-4">Event Name</span>
                                )) ||
                                (offerMethod.value === 'manual' && (
                                    <span className="font-xxs !text-fontGray font-medium col-span-4">Discount (%)</span>
                                )))}

                        {edit && (
                            <>
                                {(offerMethod.value === null || offerMethod.value === 'option') && (
                                    <span className="font-xxs !text-fontGray font-medium col-span-4">Offer</span>
                                )}
                                {offerMethod.value === 'previous' && (
                                    <span className="font-xxs !text-fontGray font-medium col-span-4">Event Name</span>
                                )}
                                {offerMethod.value === 'manual' && (
                                    <span className="font-xxs !text-fontGray font-medium col-span-4">Discount (%)</span>
                                )}
                                {editOriginalData['offerMethod'] === 'option' && (
                                    <span className="font-xxs !text-fontGray col-span-2">
                                        {editOriginalData['promotionMechanic']}
                                    </span>
                                )}
                                {editOriginalData['offerMethod'] === 'manual' && (
                                    <span className="font-xxs !text-fontGray col-span-2">
                                        {editOriginalData['discount']
                                            ? editOriginalData['discount']
                                            : editOriginalData['promotionMechanic']}
                                    </span>
                                )}
                                {editOriginalData['offerMethod'] === 'previous' && (
                                    <span className="font-xxs !text-fontGray col-span-2">
                                        {editOriginalData['promptEventName']
                                            ? editOriginalData['promptEventName']
                                            : editOriginalData['promotionMechanic']}
                                    </span>
                                )}
                                {editOriginalData['offerMethod'] === null && (
                                    <span className="font-xxs !text-fontGray col-span-2"></span>
                                )}
                            </>
                        )}
                        {content}
                    </div>

                    {/* offer type dropdown */}
                    <div
                        className={`${
                            edit ? `grid grid-cols-12 grid-container` : `flex justify-between`
                        } w-full items-center border-0 border-b border-borderLinePurpuleAlt p-2 !text-fontGray`}
                    >
                        <span className="font-xxs !text-fontGray font-medium col-span-4">Offer Type</span>
                        {edit && (
                            <span className="font-xxs !text-fontGray col-span-2">
                                {editOriginalData?.['tacticDescription'] in promoTypeColorMapping
                                    ? promoTypeColorMapping?.[editOriginalData?.['tacticDescription']]?.label
                                    : editOriginalData?.['tacticDescription']}
                            </span>
                        )}
                        <div className="col-span-6 flex justify-end">
                            <UpliftRoiDropdown
                                style={{ width: scaledWidth - 2 }}
                                value={
                                    'tacticDescription' in addLeverData
                                        ? promoTypeColorMapping?.[addLeverData?.['tacticDescription']]?.label ||
                                          addLeverData['tacticDescription']
                                        : {}
                                }
                                data={offerTypeData}
                                onChange={(val: any, item: any) => {
                                    changeInSelection('tacticDescription', val);
                                    if (edit) {
                                        trackEventMixpanel(
                                            PROMO_RECOMMENDATION_EDIT_EVENT_OFFER_TYPE_DROPDOWN_CHANGED,
                                            {
                                                modifiedValue: item?.item?.label,
                                                originalValue: editOriginalData['tacticDescription'] || '',
                                            },
                                        );
                                    } else {
                                        trackEventMixpanel(PROMO_RECOMMENDATION_ADD_EVENT_OFFER_TYPE_DROPDOWN_CHANGED, {
                                            dropdownValue: item?.item?.label,
                                        });
                                    }
                                }}
                                disabled={offerTypeLoading}
                                loading={offerTypeLoading}
                                onClick={callTactics}
                                originalROI={edit ? editOriginalData['roi'] : ''}
                                originalUPlift={edit ? editOriginalData['uplift'] : ''}
                            />
                        </div>
                    </div>
                    {/* Calender dropdown */}
                    <div
                        className={`${
                            edit ? `grid grid-cols-12 grid-container` : `flex justify-between`
                        } w-full items-center border-0 border-b border-borderLinePurpuleAlt p-2 !text-fontGray items-center`}
                    >
                        <span className="font-xxs !text-fontGray font-medium col-span-4">Select Date</span>
                        {edit && (
                            <span className="font-xxs !text-fontGray col-span-2">
                                {dayjs(editOriginalData['startDate']).format(dateFormatAlt)}
                            </span>
                        )}
                        {edit ? (
                            <div className="col-span-6 flex justify-end">
                                {/* <UpliftRoiDropdown
                                    style={{ width: scaledWidth - 2 }}
                                    //loading={allDimAndAttributeTypeList?.loading}
                                    value={'startDate' in addLeverData ? addLeverData['startDate'] : {}}
                                    data={calenderList}
                                    loading={calenderListLoading}
                                    onChange={(val: any, item: any) => {
                                        changeInSelection('startDate', val);
                                        changeInSelection('month', dayjs(new Date(val)).format('MMM'));
                                        trackEventMixpanel(PROMO_RECOMMENDATION_EDIT_EVENT_DATE_SELECTED, {
                                            originalValue: editOriginalData['startDate'] || '',
                                            modifiedValue: item?.item?.label,
                                        });
                                    }}
                                    disabled={offerListLoading}
                                    originalROI={edit ? editOriginalData['roi'] : ''}
                                    originalUPlift={edit ? editOriginalData['uplift'] : ''}
                                    onClick={callCalender}
                                /> */}
                                <DateSelectCombo
                                    style={{ width: scaledWidth - 2 }}
                                    //loading={allDimAndAttributeTypeList?.loading}
                                    value={'startDate' in addLeverData ? addLeverData['startDate'] : {}}
                                    data={calenderList}
                                    loading={calenderListLoading}
                                    onChange={(val: any, item: any) => {
                                        changeInSelection('startDate', val);
                                        changeInSelection('month', dayjs(new Date(val)).format('MMM'));
                                        trackEventMixpanel(PROMO_RECOMMENDATION_EDIT_EVENT_DATE_SELECTED, {
                                            originalValue: editOriginalData['startDate'] || '',
                                            modifiedValue: item?.item?.label,
                                        });
                                    }}
                                    originalROI={edit ? editOriginalData['roi'] : ''}
                                    originalUPlift={edit ? editOriginalData['uplift'] : ''}
                                    onClick={callCalender}
                                    onDateChange={(date: string) => changeInSelection('startDate', date)}
                                    startDay={calenderStartDay}
                                    range={tempRange}
                                />
                            </div>
                        ) : (
                            <div style={{ width: scaledWidth - 2 }} className="col-span-6 flex justify-end">
                                <Popover
                                    trigger="click"
                                    open={isOpen}
                                    onOpenChange={handleOpenChange}
                                    placement={'right'}
                                    // overlayInnerStyle={{ padding: 0 }}
                                    content={
                                        <Calender
                                            minYear={currentDate.getFullYear()}
                                            startYear={currentDate.getFullYear()}
                                            maxYear={currentDate.getFullYear() + 2}
                                            disabledDates={[dayjs(currentDate).format('MM-DD-YYYY'), null]}
                                            startDay={calenderStartDay}
                                            range={tempRange}
                                            onChange={handleDateChange}
                                            onFooterClick={() => handleOpenChange(false, false)}
                                            singleDateSelect={true}
                                        />
                                    }
                                >
                                    <div className="flex justify-center items-center w-full">
                                        <div className="cursor-pointer w-full flex justify-start gap-1 py-1 items-center px-1 border border-purpleFont rounded">
                                            <CalenderIcon />
                                            <div className="flex w-full justify-center">
                                                <span
                                                    className={`${
                                                        !stateForCalender.dateRange.includes(null) && !isOpen
                                                            ? 'text-subHeaderColor'
                                                            : dateLabel.startLabel !== 'Start Date'
                                                            ? 'text-greyFont'
                                                            : 'text-borderGrey'
                                                    }  font-xs`}
                                                >
                                                    {dateLabel.startLabel}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        )}
                    </div>
                    {/* Lower form section */}
                    {promoContext.formList.map((list: any, index: any) => {
                        return (
                            <div
                                className={`${
                                    edit ? `grid grid-cols-12 grid-container` : `flex justify-between`
                                } w-full items-center border-0 border-b border-borderLinePurpuleAlt p-2 !text-fontGray`}
                            >
                                <span className="font-xxs !text-fontGray font-medium col-span-4">{list.label}</span>
                                {edit && (
                                    <span className="font-xxs !text-fontGray w-10 col-span-2">
                                        {list.value in editOriginalData ? editOriginalData[list.value] : ''}
                                    </span>
                                )}

                                {/* todo: revert the Edit flag and make it functional {list.value == 'duration' && edit ? ( */}
                                {list.value == 'duration' && false ? (
                                    <div className="col-span-6 flex justify-end">
                                        <UpliftRoiDropdown
                                            style={{ width: scaledWidth - 2 }}
                                            //loading={allDimAndAttributeTypeList?.loading}
                                            value={'duration' in addLeverData ? addLeverData['duration'] : {}}
                                            data={durationList}
                                            onChange={(val: any, item: any) => {
                                                changeInSelection('duration', parseInt(val));
                                                trackEventMixpanel(PROMO_RECOMMENDATION_EDIT_EVENT_DURATION_CHANGED, {
                                                    originalValue: editOriginalData[list.value],
                                                    modifiedValue: item?.item?.label,
                                                });
                                            }}
                                            disabled={offerListLoading}
                                            originalROI={edit ? editOriginalData['roi'] : ''}
                                            originalUPlift={edit ? editOriginalData['uplift'] : ''}
                                            loading={durationLoading}
                                            onClick={callDuration}
                                        />
                                    </div>
                                ) : (
                                    <div className="col-span-6 flex justify-end">
                                        <span
                                            className="border border-purpleFont rounded"
                                            style={{ width: scaledWidth - 2 }}
                                        >
                                            <input
                                                onWheel={(e) => e.currentTarget?.blur()}
                                                min={'0'}
                                                className="m-0.5 focus:outline-none pl-2"
                                                style={{ width: scaledWidth - 6 }}
                                                onChange={(e) => {
                                                    changeInputForm(e, list);
                                                    if (edit) {
                                                        trackEventMixpanel(mixpanelMapping[list?.value]?.[1], {
                                                            originalValue: editOriginalData[list.value] || '',
                                                            modifiedValue: e.target.value,
                                                        });
                                                    } else {
                                                        trackEventMixpanel(mixpanelMapping[list?.value]?.[0], {
                                                            inputValue: e.target.value,
                                                        });
                                                    }
                                                }}
                                                value={list.value in addLeverData ? addLeverData[list.value] : ''}
                                                placeholder={list.placeHolder}
                                                type="number"
                                                disabled={offerMethod.value === 'previous' && index !== 0}
                                            />
                                        </span>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default AddEditLevers;
